<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <strong>{{$t('ACLGROUPS')}}</strong>
                        <div class="card-actions">
                            <a href="#" class="btn btn-minimize" v-on:click.stop="newAclVisible = !newAclVisible">
                                <icon :icon="(newAclVisible) ? 'angle-up' : 'angle-down'"></icon>
                            </a>
                        </div>
                    </div>
                    <div v-if="newAclVisible">
                      <div class="card-body">
                          <div class="row mb-lg">
                              <div class="col-sm-12">
                                  <b-form-fieldset v-bind:label="$t('GROUPNAME')">
                                      <inputvalidation :formerror="formGroupError" name="groupName">
                                          <b-form-input type="text" v-model="formGroupData.groupName" v-bind:placeholder="$t('GROUPNAME')"></b-form-input>
                                      </inputvalidation>
                                  </b-form-fieldset>
                              </div>
                          </div>
                          <div class="row mb-lg">
                              <div class="col-sm-12">
                                  <b-form-fieldset v-bind:label="$t('COPYACLFROMGROUP')">
                                    <b-form-select :options="aclGroups.root" v-model="formGroupData.copyGroupId" value-field="groupId" text-field="groupName"></b-form-select>
                                  </b-form-fieldset>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-sm-12">
                                  <p class="bg-danger" v-if="formGroupError.error && typeof formGroupError.notice == 'string'">{{formGroupError.notice}}</p>
                                  <b-button type="submit" size="md" variant="primary" v-on:click.prevent="saveRow(formGroupData)" class="pull-right">{{$t('SUBMIT')}}</b-button>
                              </div>
                          </div>
                      </div>
                      <div class="card-body acl-table" v-if="typeof aclGroups.root != 'undefined' && aclGroups.root.length">
                          <table class="table table-responsive-sm table-striped">
                              <thead>
                                  <tr>
                                      <th>{{$t('ID')}}</th>
                                      <th>{{$t('GROUPNAME')}}</th>
                                      <th>{{$t('SAVE')}}</th>
                                      <th>{{$t('DELETE')}}</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="(group, g) in aclGroups.root" :key="g">
                                      <td>{{group.groupId}}</td>
                                      <td>{{group.groupName}}</td>
                                      <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="saveRow(group)">{{$t('SAVE')}}</b-button></td>
                                      <td><b-button type="reset" size="sm" variant="secondary" v-on:click.prevent="deleteRow(group.groupId)">{{$t('DELETE')}}</b-button></td>
                                  </tr>
                              </tbody>
                          </table>
                          <nav>
                              <b-pagination align="center" :total-rows="parseInt(aclGroups.totalCount)" v-model="paginationGroups.currentPage" :per-page="paginationGroups.limit"></b-pagination>
                          </nav>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <b-card>
                    <div slot="header">
                        <strong>{{$t('NEWACLOBJECT')}}</strong>
                    </div>
                    <div class="row mb-lg">
                        <div class="col-sm-12">
                            <b-form-fieldset v-bind:label="$t('OBJECTNAME')">
                                <inputvalidation :formerror="formError" name="objectName">
                                    <b-form-input type="text" v-model="formData.objectName" v-bind:placeholder="$t('OBJECTNAME')"></b-form-input>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div class="row mb-lg">
                        <div class="col-sm-12">
                            <b-form-fieldset v-bind:label="$t('OBJECTFUNCTION')">
                                <b-form-input type="text" v-model="formData.objectFunction" v-bind:placeholder="$t('OBJECTFUNCTION')"></b-form-input>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <b-form-fieldset v-bind:label="$t('OBJECTDESCRIPTION')">
                                <b-form-textarea type="text" v-model="formData.objectDescription" v-bind:placeholder="$t('OBJECTDESCRIPTION')"></b-form-textarea>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div slot="footer">
                        <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
                        <b-button type="submit" size="md" variant="primary" v-on:click.prevent="saveAcl" class="pull-right">{{$t('SUBMIT')}}</b-button>
                    </div>
                </b-card>
            </div>
            <!--/.col-->
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        {{$t('ACLOBJECTS')}}
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-3">
                                <b-form-fieldset v-bind:label="$t('GROUP')">
                                    <b-form-select :options="aclGroups.root" v-model="searchGroupId" value-field="groupId" text-field="groupName"></b-form-select>
                                </b-form-fieldset>
                            </div>
                            <div class="col-sm-3">
                                <b-form-fieldset v-bind:label="$t('SEARCH')">
                                    <b-form-input v-model="pagination.query"></b-form-input>
                                </b-form-fieldset>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="typeof acl.root == 'undefined' || !acl.root.length">
                        <p class="center">{{$t('NODATAFOUND')}}</p>
                    </div>
                    <div class="card-body acl-table" v-if="typeof acl.root != 'undefined' && acl.root.length">
                        <table class="table table-responsive-sm table-striped">
                            <thead>
                                <tr>
                                    <th>{{$t('ID')}}</th>
                                    <th>{{$t('OBJECTNAME')}}</th>
                                    <th>{{$t('OBJECTFUNCTION')}}</th>
                                    <th>{{$t('INSERTPRIVILAGE')}}</th>
                                    <th>{{$t('UPDATEPRIVILAGE')}}</th>
                                    <th>{{$t('DELETEPRIVILAGE')}}</th>
                                    <th>{{$t('INSTANTIATE')}}</th>
                                    <th>{{$t('OWNERHANDLING')}}</th>
                                    <th>{{$t('COMPANYHANDLING')}}</th>
                                    <th>{{$t('DELETE')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="priv in acl.root">
                                    <td>{{priv.objectId}}</td>
                                    <td>{{priv.objectName}}</td>
                                    <td>{{priv.objectFunction}}</td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.insertPrivilage == 1) ? true : false" v-on:change="setAcl(priv, 'insertPrivilage')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.updatePrivilage == 1) ? true : false" v-on:change="setAcl(priv, 'updatePrivilage')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.deletePrivilage == 1) ? true : false" v-on:change="setAcl(priv, 'deletePrivilage')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.instantiate == 1) ? true : false" v-on:change="setAcl(priv, 'instantiate')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.ownerAction == 1) ? true : false" v-on:change="setAcl(priv, 'ownerAction')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.companyAction == 1) ? true : false" v-on:change="setAcl(priv, 'companyAction')" />
                                    </td>
                                    <td>
                                        <b-button type="reset" size="sm" variant="secondary" v-on:click.prevent="deleteAcl(priv.objectId)"><i class="fa fa-ban"></i> {{$t('DELETE')}}</b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <nav>
                            <b-pagination align="center" :total-rows="parseInt(acl.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import cSwitch from '../../components/lib/Switch'
import { mapActions, mapGetters } from 'vuex'
import AclApi from '@/api/admin/Acl'
import AclGroupsApi from '@/api/admin/AclGroups'

export default {
  name: 'Acl',
  components: {
    cSwitch
  },
  data: function()
  {
    return {
      acl: {},
      aclGroups: {},
      formGroupData: {
        groupName: '',
        copyGroupId: ''
      },
      formData: {
        id: '',
        objectName: '',
        objectFunction: '',
        objectDescription: ''
      },
      formError: {},
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      },
      paginationGroups:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      },
      searchGroupId: 2,
      newAclVisible: false,
      formGroupError: {}
    }
  },
  created: function()
  {
    var me = this;
    me.getAcl();
    me.getAclGroups();
  },
  methods:
  {
    saveAcl: function()
    {
      var me = this;

      AclApi.saveAcl(me.formData, function(val)
      {
        if(val.error)
        {
          me.formError = val;
        }
        else
        {
          me.formError = {};
          me.formData = {
            id: '',
            objectName: '',
            objectFunction: '',
            objectDescription: ''
          };
          me.getAcl();
        }
      })
    },
    setAcl(priv, type)
    {
      var me = this;
      priv[type] = (priv[type] == 0) ? 1 : 0;
      priv.groupId = me.searchGroupId;
      AclApi.updatePrivilageByGroupId(priv, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
        }

        me.getAcl();
      })
    },
    getAcl: function()
    {
      var me = this;
      AclApi.getPrivilagesByGroupId(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.notice(data);
          return;
        }
        me.acl = data;
      });
    },
    getAclGroups: function()
    {
      var me = this;
      AclGroupsApi.selectRow(me.getGroupParams, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.notice(data);
          return;
        }
        me.aclGroups = data;
      });
    },
    deleteAcl: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          AclApi.deleteAcl({id: id}, function(data)
          {
            me.$notify.notice(data);
            me.getAcl();
          })
        }
      })
    },
    saveRow: function(item)
    {
      var me = this;

      if(typeof item.groupId != 'undefined')
      {
        item.id = item.groupId;
        delete(item.groupId);
      }

      AclGroupsApi.save(item, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
          me.formGroupError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formGroupError = {};
          me.getAclGroups();
        }
      })
    },
    deleteRow: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          AclGroupsApi.deleteRow({id: id}, function(data)
          {
            me.$notify.notice(data);
            me.getAclGroups();
          })
        }
      })
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getAcl();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getAcl();
        me.pagination.searchTimeout = false;
      }, 300);
    },
    'paginationGroups.currentPage': function(val)
    {
      var me = this;
      me.getAclGroups();
    },
    'paginationGroups.query': function(val)
    {
      var me = this;

      if(me.paginationGroups.searchTimeout != false) clearTimeout(me.paginationGroups.searchTimeout);

      me.paginationGroups.searchTimeout = setTimeout(function()
      {
        me.getAclGroups();
        me.paginationGroups.searchTimeout = false;
      }, 300);
    },
    searchGroupId()
    {
      var me = this;
      me.getAcl();
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      data.groupId = me.searchGroupId;
      return data;
    },
    getGroupParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.paginationGroups, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
